import { closeDialog, updateDialog } from '@Containers/Dialogs/DialogsActions';
import Auth from '@Services/Auth';
import Catalyst from '@Services/Catalyst';

import {
  resetPasswordWithTokenDialogSetConfirmationPasswordReducerType,
  resetPasswordWithTokenDialogSetIsLoadingReducerType,
  resetPasswordWithTokenDialogSetNewPasswordReducerType,
  typeOfResetPasswordWithTokenDialog,
} from './ResetPasswordWithTokenDialogConstants';

import {
  confirmationPassword as confirmationPasswordSelector,
  newPassword as newPasswordSelector,
} from './ResetPasswordWithTokenDialogSelectors';

export const openResetPasswordWithTokenDialog = (props) => (dispatch) => {
  dispatch(
    updateDialog({
      id: typeOfResetPasswordWithTokenDialog,
      dialogType: typeOfResetPasswordWithTokenDialog,
      ...props,
    })
  );
};

export const closeResetPasswordWithTokenDialog = () => (dispatch) =>
  dispatch(
    closeDialog({
      id: typeOfResetPasswordWithTokenDialog,
    })
  );

export function trackAdobeAnalyticsError(errors, prefix) {
  if (errors && errors.length) {
    errors.forEach((error) =>
      Catalyst.trackError(
        {
          message: error,
          component: 'Reset password',
        },
        prefix
      )
    );
  }
}

export function setIsLoading(isLoading) {
  return {
    type: resetPasswordWithTokenDialogSetIsLoadingReducerType,
    payload: { isLoading },
  };
}

export function setNewPassword(newPassword) {
  return {
    type: resetPasswordWithTokenDialogSetNewPasswordReducerType,
    payload: { newPassword },
  };
}

export function setConfirmationPassword(confirmationPassword) {
  return {
    type: resetPasswordWithTokenDialogSetConfirmationPasswordReducerType,
    payload: { confirmationPassword },
  };
}

export const submit = (token) => async (dispatch, getState) => {
  const newPassword = newPasswordSelector(getState());
  const confirmationPassword = confirmationPasswordSelector(getState());

  if (!(newPassword.value && confirmationPassword.value) || !(newPassword.isValid && confirmationPassword.isValid)) {
    return;
  }

  dispatch(setIsLoading(true));

  await Auth.resetPasswordWithToken(token, newPassword.value)
    .then(() => {
      dispatch(closeResetPasswordWithTokenDialog());
    })
    .finally(() => {
      dispatch(setIsLoading(false));
    })
    .catch(Logger.error);
};
